"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfRecovery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const testimonials = [{
    author: "Elena K.",
    quote: "The chiropractic care at Bodywerks transformed my daily life. I can finally enjoy the Cyprus sunshine without constant back pain or stiffness.",
    position: "Expat in Limassol",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/avatar_elena_limassol.png",
    rating: 5
  }, {
    author: "Andreas M.",
    quote: "Professional, precise, and genuinely caring. The acupuncture treatments in Nicosia helped me manage my chronic migraines effectively.",
    position: "Local, Nicosia",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/avatar_andreas_nicosia.png",
    rating: 5
  }, {
    author: "Sarah J.",
    quote: "As an athlete, I need experts who understand movement. Bodywerks is my go-to for maintaining peak performance and recovery in Cyprus.",
    position: "Expat in Nicosia",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/avatar_sarah_expat.png",
    rating: 5
  }, {
    author: "Costas P.",
    quote: "The most welcoming clinic I've visited. They take the time to explain everything, making the healing process stress-free and truly effective.",
    position: "Local, Limassol",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/avatar_costas_local.png",
    rating: 5
  }];
  return <section data-section-id="19632" id="patient-journeys" ref={ref} className={`bg-background text-foreground py-24 px-4 overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-5xl font-serif font-medium tracking-tight text-primary">
            Patient Journeys
          </h2>
          <p className="text-secondary max-w-2xl mx-auto text-lg font-sans">
            Real stories from our community in Limassol and Nicosia who have
            reclaimed their movement and vitality through expert care.
          </p>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full relative">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} className="md:basis-full lg:basis-full">
                <div className="p-4" data-index={i}>
                  <div className="flex flex-col items-center text-center space-y-8">
                    {}
                    <div className="relative">
                      <Quote className="w-16 h-16 text-accent opacity-60 rotate-180" strokeWidth={1.5} />
                    </div>

                    {}
                    <div className="flex gap-1">
                      {[...Array(testimonial.rating)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="w-5 h-5 fill-accent text-accent" />)}
                    </div>

                    {}
                    <blockquote className="text-xl md:text-3xl font-medium leading-relaxed max-w-3xl text-primary/90 font-serif italic">
                      &ldquo;{testimonial.quote}&rdquo;
                    </blockquote>

                    {}
                    <div className="flex flex-col items-center gap-3 pt-4">
                      <SafeHydrate><Avatar className="w-16 h-16 border-2 border-accent/20 shadow-md">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                        <AvatarFallback className="bg-muted text-secondary text-lg font-sans">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="space-y-1">
                        <div className="font-semibold text-lg text-primary font-sans">
                          {testimonial.author}
                        </div>
                        <div className="text-sm text-secondary uppercase tracking-widest font-medium font-sans">
                          {testimonial.position}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="hidden md:block">
            <CarouselPrevious className="left-0 -translate-x-12 lg:-translate-x-24 border-accent hover:bg-accent/10 hover:text-accent text-accent transition-all duration-300" />
            <CarouselNext className="right-0 translate-x-12 lg:translate-x-24 border-accent hover:bg-accent/10 hover:text-accent text-accent transition-all duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}